export const SCRAM_ITERATION_COUNT = 210000;
export const SCRAM_HASH_FUNCTION = 'SHA-512';
export const CLIENT_KEY = 'Client Key';
